const HTML_CODE_BLOCK_PATTERN = /(<pre[^>]*>[\s\S]*?<\/pre>|<code[^>]*>[\s\S]*?<\/code>)/i;
export const replaceOutsideHtmlCodeBlocks = (html, regex, replacer) => {
  if (!regex.global) {
    throw new Error(`replaceOutsideHtmlCodeBlocks: regex must have the 'g' flag, otherwise only the first match per segment will be replaced. Received: ${regex}`);
  }
  return html.split(HTML_CODE_BLOCK_PATTERN).map((part, index) => index % 2 === 0 ? part.replace(regex, replacer) : part).join('');
};